import ROUTES  from 'constants/routes';
import { RouteProps } from 'react-router-dom';
import Category from 'screens/Category/Category';
import Home from 'screens/Home/Home';

const routes: RouteProps[] = [
  {
    exact: true,
    path: ROUTES.HOME,
    component: Home,
  },
  {
    exact: true,
    path: ROUTES.CATEGORY,
    component: Category,
  },
];

export default routes;